////////////////////////////////DB Values
var Users_Collection = "Musomi_App_Users";
var Users_Storage_Path = "Musomi_App/Users";
var Screenshots_Storage_Path = "Musomi_App/Screenshots";
var Chats_Storage_Path = "Musomi_App/Chats";
var Products_Storage_Path = "Musomi_App/Products";
var Qualification_Storage_Path = "Musomi_App/Users/Qualification";
var Resources_Storage_Path = "Musomi_App/Resources";

var Emails_Collection = "emails";

var Requests_Collection = "Musomi_App_Requests";
var Orders_Collection = "Musomi_App_Orders";
var Products_Collection = "Musomi_App_Products";
var Monthly_Stats_Collection = "Musomi_App_Monthly_Stats";
var Shops_Collection = "Musomi_App_Shops";
var Bids_Collection = "Musomi_App_Bids";
var Notifications_Collection = "notifications";
var Ratings_Collection = "Musomi_App_Ratings";
var Payments_Collection = "Musomi_App_Payments";
var Withdrawals_Collection = "Musomi_App_Withdrawals";

var Chat_Message_Collection = "Musomi_App_Chat_Message";
var Chat_Collection = "Musomi_App_Chat";

var Message_Collection = "Musomi_App_Messages";
var Bookings_Collection = "Musomi_App_Bookings";
var Slots_Collection = "Musomi_App_Slots";
var Subjects_Collection = "Musomi_App_Subjects";
var Assessments_Collection = "Musomi_App_Assessments";
var Assessment_Submissions_Collection = "Musomi_App_Assessment_Submissions";
var Session_Reports_Collection = "Musomi_App_Session_Reports";
var Tutor_Notes_Collection = "Musomi_App_Tutor_Notes";
/////////////////////////////////


//////////Keys
var Google_Maps_API_Key = "AIzaSyCseKZZdidwHZ6Pm8MdmB_LcvWm69TAByc";
var Vapid_Key = 'BJmAPL8blUyXl5x615cSqeFnkWs7s0BOjugsJl_0uPD-QNqKxuZlWledosgwSIpVxn2J17NUL_atAX3pA9q3v6o';
///////////////


////////////CONTACTS & LINKS
var Support_Email = "tyrese.makhubele@gmail.com";
var Admin_Email = "tyrese.makhubele@gmail.com";
var Admin_Phone_Number = "277608903707";
var Admin_Emails_Array = ['tyrese.makhubele@gmail.com', 'tyrese.makhubele@gmail.com'];
var Admin_Dashboard_Url = "https://";
////////////////////


////////////ACCOUNT TYPES
var Admin_Account_Role = "Admin";
var Primary_Account_Role = "Tutor";
var Secondary_Account_Role = "Student";
//////////////////////


// Export variables in a single object
module.exports = { 
    Users_Collection,
    Users_Storage_Path,
    Screenshots_Storage_Path,
    Chats_Storage_Path,
    Qualification_Storage_Path,
    Resources_Storage_Path,
    Payments_Collection,
    Google_Maps_API_Key,
    Vapid_Key,
    Support_Email,
    Requests_Collection,
    Monthly_Stats_Collection,
    Emails_Collection,
    Shops_Collection,
    Bids_Collection,
    Notifications_Collection,
    Chat_Collection,
    Chat_Message_Collection,
    Message_Collection,
    Ratings_Collection,
    Products_Storage_Path,
    Orders_Collection,
    Products_Collection,
    Bookings_Collection,
    Slots_Collection,
    Subjects_Collection,
    Assessments_Collection,
    Assessment_Submissions_Collection,
    Session_Reports_Collection,
    Tutor_Notes_Collection,
    Admin_Email,
    Admin_Phone_Number,
    Admin_Emails_Array,
    Admin_Dashboard_Url,
    Admin_Account_Role,
    Primary_Account_Role,
    Secondary_Account_Role,
    Withdrawals_Collection
};
